import React from 'react';
import { ModalBody, ModalHeader } from 'baseui/modal';
import CustomModal from 'presentation/components/modal/CustomModal';
import CustomModalFooter from 'presentation/components/modal/CustomModalFooter';
import { Col, Container, Row } from 'react-bootstrap';
import { Button } from '@techem/ui-components';
import { SIZE } from 'baseui/button';
import { TrackerUtil } from 'tracking/TrackerUtil';
import EEDModalContent from 'presentation/components/shared/EEDModalContent';
import { useStyletron } from 'baseui';
import { useTranslation } from 'react-i18next';

interface EEDModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const EEDModal: React.FC<EEDModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [css] = useStyletron();
  return (
    <CustomModal
      isOpen={isOpen}
      modalId="modal-eed"
      onClose={() => {
        TrackerUtil.trackBtnClickByIdentifier('close', 'modal-eed');
        onClose();
      }}
      additionalTestId="eed"
    >
      <ModalHeader className="pe-3">
        <h3
          className={css({
            whiteSpace: 'normal',
            overflowWrap: 'break-word'
          })}
        >
          {t('eedModalTitle')}
        </h3>
      </ModalHeader>
      <ModalBody>
        <EEDModalContent />
      </ModalBody>
      <CustomModalFooter>
        <Container fluid>
          <Row className="justify-content-end">
            <Col xs={12} md="auto">
              <Row className="justify-content-center">
                <Col xs="auto" className="my-2 my-md-0">
                  <Button
                    size={SIZE.large}
                    onClick={onClose}
                    additionalTestId="close"
                    trackClickUsingTestId={(buttonIdentifier) => {
                      TrackerUtil.trackBtnClickByIdentifier(buttonIdentifier, 'modal-eed');
                    }}
                  >
                    {t('eedConfirmButtonText')}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </CustomModalFooter>
    </CustomModal>
  );
};

export default EEDModal;
